module.exports = __webpack_public_path__ + "prod/1.42.2/img/estate-chain.6e53c42a.png";